function addError(item, message)
{
    jQuery(item).addClass("has-error");   
    
    //if already has an error text, overwrite
    var prev = jQuery(item).prev();
    if (prev.hasClass('has-error-text'))
    {
        prev.text(message);
    }else{
        jQuery(item).after(jQuery("<span class='has-error-text'></span>").text());
    }
    if (!jQuery(item).hasClass("error-undo"))
    {
        var removeError=function() {
            var prev = jQuery(this).prev();
            if (prev.hasClass('has-error-text'))
            {
                prev.remove();
            }
            
            jQuery(this).removeClass("has-error");
        };
        //remove error msg on keydown
        jQuery(item).keydown(removeError);
        jQuery(item).change(removeError);

        jQuery(item).addClass("error-undo");
    }
}

function checkFormRequired(theform)
{
    var theret = false;
    jQuery(theform).find(".form-required").each(function(i, item) {
        if ((jQuery(item).val() == "") || (jQuery(item).val() == null))
        {
            var err = jQuery(item).attr("data-required");
            addError(item, err == '' ? err : selectposition_ajax.translations.kotelezo_csillag );
            theret = true;
        }
    });

    return theret;
}

jQuery(function () {

    (function($) {
    //modify all required stuff
    $('form.form-validate [required]').each(function() {
        $(this).removeAttr('required').addClass('form-required');
    });
    })(jQuery);
});

